// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__yUCSQ","modalWindow":"styles_modalWindow__Thmwy","activemodalWindow":"styles_activemodalWindow__PtMvw","btnExit":"styles_btnExit__OHcH4"};